import {generateRow} from 'utils/helpers/RowHelper';
import {Grid, IconButton, Typography, useTheme} from '@material-ui/core';
import {EccFileDownload} from 'utils/rows/TestRows';
import {timestampToDate} from 'utils/processing/dates';
import {CustomTooltip} from 'commons/Tooltip/CustomTooltip';
import {faCircle, faTrash} from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import CustomIcon from 'commons/Icon/CustomIcon';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { localize } from 'commons/LocalizedText/LocalizedText';


const TypeColorIndicator = ({type = 'default'}) => {
  const theme = useTheme();
  const colorMap = {
    'LaboratoryContract': theme.palette.warning.dark,
    'LaboratoryDocument': theme.palette.secondary.main,
    'ISO': theme.palette.error.main,
    'default': theme.palette.grey
  }

  return (
    <FontAwesomeIcon
      color={colorMap[type]}
      icon={faCircle}
    />
  );
}

export const documentNameHeader = generateRow({
  name: 'name',
  label: 'laboratoryFile.name',
  width: '30%',
  mobileWidth: '40%',
  template: (row) => {
    return (
      <Grid
        alignItems="center"
        container
        direction="row"
        justifyContent="flex-start"
        spacing={1}
        style={{overflow: 'hidden', textOverflow: 'ellipsis', flexWrap: 'nowrap'}}
      >
        { row?.idCrypted && row?.type && (
          <Grid item>
            <EccFileDownload file={row}/>
          </Grid>
        )}
        <Grid item>
          <CustomTooltip title={`${row?.name}`}>
            <Typography variant="body2">{row?.name}</Typography>
          </CustomTooltip>
        </Grid>
      </Grid>
    )
  }
});

export const documentTypeHeader = generateRow({
  name: 'type',
  label: 'laboratoryFile.type',
  width: '10%',
  mobileWidth: '40%',
  template: (row) => (
    <Grid
      alignItems="center"
      container
      direction="row"
      justifyContent="flex-start"
      spacing={1}
      style={{overflow: 'hidden', textOverflow: 'ellipsis', flexWrap: 'nowrap'}}
    >
      <Grid item>
        <TypeColorIndicator type={row?.type?.id}/>
      </Grid>
      <Grid item xs>
        <Typography variant="body2">{localize(row?.type?.id)}</Typography>
      </Grid>
    </Grid>
  )
});

export const creationDateHeader = generateRow({
  name: 'creationDate',
  label: 'laboratoryFile.creationDate',
  width: '10%',
  mobileWidth: '40%',
  template: (row) => (
    <Typography variant="body2">{timestampToDate(row?.creationDate)}</Typography>
  )
});

export const creationUserHeader = generateRow({
  name: 'creationUser',
  label: 'laboratoryFile.creationUser',
  width: '15%',
  mobileWidth: '40%',
  template: (row) => (
    <div>
      {`${row?.creationUserFirstname ?? ''} ${row?.creationUserLastname ?? ''}`}
    </div>
  )
});

export const descriptionHeader = generateRow({
  name: 'description',
  label: 'laboratoryFile.description',
  width: '25%',
  mobileWidth: '40%',
  template: (row) => (
    <div>
      {row?.description}
    </div>
  )
});

export const actionsHeader = (onDelete) => generateRow({
  name: 'actions',
  width: '10%',
  mobileWidth: '40%',
  isSortable: false,
  template: (row) => (
    <div>
      {row?.type?.id === 'LaboratoryDocument' && row.idCrypted && (
        <IconButton
          onClick={() => onDelete(row)}
        >
          <CustomIcon
            color="red"
            icon={faTrash}
            size="xs"
          />
        </IconButton>
      )}
    </div>
  )
});